import { Component, Input } from '@angular/core';
import { CPPCOIOrderSplitDetails } from './../../../models/COI/CPPCOIOrderSummaryVM';
import { trigger, state, style, transition, animate } from '@angular/animations';

@Component({
  selector: 'app-cpp-coi-grid-view',
  templateUrl: './cpp-coi-grid-view.component.html',
  styleUrls: ['./cpp-coi-grid-view.component.scss'],
  animations: [
    trigger('detailExpand', [
      state('collapsed', style({ height: '0px', minHeight: '0', display: 'none' })),
      state('expanded', style({ height: '*' })),
      transition('expanded <=> collapsed', animate('225ms cubic-bezier(0.4, 0.0, 0.2, 1)')),
    ]),
    trigger('fadeInOut', [
      transition(':enter', [   // :enter is alias to 'void => *'
        style({ opacity: 0 }),
        animate(400, style({ height: '0px', opacity: 1 }))
      ]),
      transition(':leave', [   // :leave is alias to '* => void'
        animate(400, style({ height: '0px', opacity: 0 }))
      ])
    ])
  ]
})
export class CppCoiGridViewComponent {
  gridDataList: any;
  itemList = new Array();
  @Input()
  set gridData(val: CPPCOIOrderSplitDetails) {
    this.gridDataList = val.productDetail;
  }
  get gridData(): CPPCOIOrderSplitDetails {
    return this.gridDataList;
  }
  displayedColumns: string[] = ['product', 'detail', 'quantity', 'orderUOM', 'packageSize'];
  displayedFooterColumns: string[] = this.displayedColumns;

  constructor() { }

  // Total price of all the items in the grid displayed
  getTotalPrice() {
    let totalPrice = 0;
    this.gridDataList.forEach(x => {
      totalPrice += x.totalPrice;
    });
    return totalPrice;
  }

  // Show or Hide Product detail
  showProductDetails(item) {
    if (item.lineStatus == 'CANCELLED') {
      return;
    }
    item.isDetailDisplayed = !item.isDetailDisplayed;
  }
}
